<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <b-tabs
          content-class="mt-3"
          active-nav-item-class="font-weight-bold"
          v-model="currentTab"
        >
          <b-tab title="Form" active>
            <b-form class="p-2" @submit.prevent="onSubmit" :method="'POST'">
              <input type="hidden" name="_token" :value="csrf" />
              <input type="hidden" name="_method" value="PUT" />

              <common-loading
                :message="$t('persons.fetching_person')"
                v-if="states.fetching"
              />

              <b-alert
                :show="personId && !(permissions.indexOf('person-edit') !== -1)"
                variant="warning"
              >
                <em class="fa fa-info-circle mr-2"></em>
                {{ $t("commons.read_only") }}
              </b-alert>

              <div class="row">
                <div class="col-lg-6">
                  <b-form-group
                    id="fieldset-id"
                    label-for="id"
                    label-size="lg"
                    label-class="font-weight-bold pb-0"
                    class="required"
                  >
                    <template slot="label">
                      <span v-text="$t('commons.id')" />
                    </template>
                    <b-form-input
                      id="id"
                      name="id"
                      v-model.trim="id"
                      disabled
                    />
                  </b-form-group>
                </div>
                <div class="col-lg-6 pl-3 pr-3">
                  <b-form-group
                    id="fieldset-mobileNumber"
                    label-for="mobileNumber"
                    label-size="lg"
                    label-class="font-weight-bold pb-0"
                  >
                    <template slot="label">
                      <span v-text="$t('persons.mobile_number')" />
                    </template>
                    <b-form-input
                      id="mobile_number"
                      name="mobile_number"
                      v-model.trim="mobileNumber"
                      maxlength="200"
                      :placeholder="$t('persons.enter_mobile_number')"
                      disabled
                    />
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <b-form-group
                    id="fieldset-active"
                    label-for="active"
                    label-size="lg"
                    label-class="font-weight-bold pb-0"
                  >
                    <template slot="label">
                      <span v-text="$t('commons.active')" />
                    </template>

                    <toggle-button
                      v-model="isActive"
                      :labels="{ checked: 'On', unchecked: 'Off' }"
                      :sync="true"
                    />
                  </b-form-group>
                </div>
              </div>

              <b-form-group
                label-for="attributes"
                label-size="lg"
                label-class="font-weight-bold pb-0"
                class="required"
              >
                <template slot="label">
                  <span v-text="$t('commons.attributes')" />
                </template>
                <v-jsoneditor
                  v-model="form.attributes"
                  :options="options"
                  :plus="false"
                  @error="errors['attributesError'] = true"
                  @input="errors['attributesError'] = false"
                  height="350px"
                />
                <input
                  type="hidden"
                  :value="form.attributesJson"
                  name="attributes"
                />
                <div v-if="hasError('attributes')">
                  <div
                    class="alert alert-danger mt-1"
                    v-if="show_errors"
                    v-text="$t('commons.required_field_error')"
                  ></div>
                </div>
                <div v-if="errors['attributesError']">
                  <div
                    class="alert alert-danger mt-1"
                    v-if="show_errors"
                    v-text="$t('commons.invalid_json_error')"
                  ></div>
                </div>
              </b-form-group>

              <div class="row">
                <div class="col-lg-12 pt-3">
                  <b-form-group
                    label-for="type"
                    label-size="lg"
                    label-class="font-weight-bold pb-0"
                  >
                    <template slot="label">
                      <span v-text="$t('persons.message_templates')" />
                      <em
                        class="fa fa-gear fa-spin text-primary"
                        v-if="states.fetching || states.removing"
                      ></em>
                    </template>

                    <b-tabs
                      content-class="mt-3"
                      active-nav-item-class="font-weight-bold"
                      v-model="interaction"
                      @input="onTabChange"
                    >
                      <b-tab title="Inbound" active>
                        <div
                          v-if="
                            !states.fetching &&
                            inbound_messages.length == 0 &&
                            !states.searching
                          "
                          class="row pb-1"
                        >
                          <div class="col-lg-5 pr-3 pl-3">
                            <div>
                              <span
                                class="font-weight-bold text-primary"
                                v-text="$t('pharmaops.no_message_templates')"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row pb-1">
                          <div class="col-12 pr-0 mb-1">
                            <div class="float-right">
                              <common-paginator />
                            </div>
                          </div>
                        </div>
                        <!-- Header -->
                        <b-table
                          striped
                          hover
                          :items="items"
                          :fields="inboundMessageFields"
                        ></b-table>
                        <common-loading
                          :message="$t('commons.loading')"
                          v-if="states.searching"
                        />
                      </b-tab>

                      <b-tab title="Outbound">
                        <div
                          v-if="
                            !states.fetching &&
                            outbound_messages.length == 0 &&
                            !states.searching
                          "
                          class="row pb-1"
                        >
                          <div class="col-lg-5 pr-3 pl-3">
                            <div>
                              <span
                                class="font-weight-bold text-primary"
                                v-text="$t('pharmaops.no_message_templates')"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row pb-1">
                          <div class="col-12 pr-0 mb-1">
                            <div class="float-right">
                              <common-paginator />
                            </div>
                          </div>
                        </div>
                        <b-table
                          striped
                          hover
                          :items="items"
                          :fields="outboundMessageFields"
                        ></b-table>
                        <common-loading
                          :message="$t('commons.loading')"
                          v-if="states.searching"
                        />
                      </b-tab>
                    </b-tabs>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 p-3">
                  <b-form-group
                    label-for="type"
                    label-size="lg"
                    label-class="font-weight-bold pb-0"
                  >
                    <template slot="label">
                      <span v-text="$t('persons.number_validation_info')" />
                      <em
                        class="fa fa-gear fa-spin text-primary"
                        v-if="numberValidate == null"
                      ></em>
                    </template>
                    <div class="row pb-1" v-if="numberValidate != null">
                      <b-table
                        striped
                        hover
                        :items="numberValidateFormatted"
                        :fields="numberValidateFields"
                      ></b-table>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <audit-fields :show="true" />

              <b-form-group>
                <b-button
                  type="submit"
                  variant="primary"
                  v-text="$t('buttons.update')"
                  :disabled="
                    disableForm ||
                    !(
                      permissions.indexOf('person-edit') !== -1 &&
                      permissions.indexOf('person-read') !== -1
                    )
                  "
                ></b-button>
                <b-button
                  class="btn btn-danger"
                  v-text="$t('buttons.cancel')"
                  :href="$routes('program.persons.index')"
                  :disabled="disableCancel"
                ></b-button>
              </b-form-group>

              <common-loading
                :message="$t('persons.saving')"
                v-if="states.saving"
              />
              <b-alert variant="danger" :show="states.showErrors && hasErrors">
                <em class="fa fa-times-circle mr-2"></em>
                {{ $t("commons.form_error") }}
              </b-alert>
              <b-alert variant="success" :show="states.showSuccess">
                <em class="fa fa-check-circle mr-2"></em>
                {{ $t("persons.saved_successfully") }}
              </b-alert>

              <b-alert variant="danger" :show="errorMessage != null">
                <em class="fa fa-times-circle mr-2"></em>
                <span v-html="errorMessage"></span>
              </b-alert> </b-form
          ></b-tab>
          <b-tab title="History" v-if="personId != null" lazy>
            <b-card-text>
              <show-history
                :id="personId"
                :instance-id="instanceId"
                :callback="PersonsApi.find"
              ></show-history>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import PersonsApi from "../../../apis/PersonsApi";
import { useManageAttributes } from "../../../stores/manage-attributes";
import { useSearch } from "../../../stores/search";

export default {
  props: {
    personId: String,
    permissions: {
      type: Object | Array,
    },
  },
  created() {
    this.initForm();
    this.useManageAttributes.updateStates({
      showJsonEditor: true,
      allowBase64EncDec: false,
    });
    this.fetchPerson();
    this.useSearch.updateStates({
      searching: true,
    });
  },
  data() {
    return {
      instanceId: window.Laravel.selected_instance
        ? window.Laravel.selected_instance.id
        : null,
      csrf: document.head.querySelector('meta[name="csrf-token"]').content,
      currentTab: 0,
      PersonsApi: PersonsApi,
      show_errors: false,
      errors: {
        attributesError: false,
      },
      options: { mode: "code", mainMenuBar: false, statusBar: true },
      inbound_messages: [],
      outbound_messages: [],
      interaction: 0,
      inboundMessageFields: [
        {
          key: "inboundMessageId",
          label: this.$t("persons.inboundMessageId"),
          sortable: true,
        },
        {
          key: "message",
          label: this.$t("persons.message"),
          sortable: true,
        },
        {
          key: "messageAlias",
          label: this.$t("persons.messageAlias"),
          sortable: true,
        },
        {
          key: "messageEngine",
          label: this.$t("persons.messageEngine"),
          sortable: true,
        },
        {
          key: "originationNumber",
          label: this.$t("persons.originationNumber"),
        },
        {
          key: "lastModifiedTime",
          label: this.$t("persons.lastModifiedTime"),
          sortable: true,
        },
      ],
      outboundMessageFields: [
        {
          key: "messageTemplateId",
          label: this.$t("persons.messageTemplateId"),
          sortable: true,
        },
        {
          key: "message",
          label: this.$t("persons.message"),
          sortable: true,
        },
        {
          key: "messageEngine",
          label: this.$t("persons.messageEngine"),
          sortable: true,
        },
        {
          key: "originationNumber",
          label: this.$t("persons.originationNumber"),
        },
        {
          key: "destinationNumber",
          label: this.$t("persons.destinationNumber"),
          sortable: true,
        },
        {
          key: "deliveryStatus",
          label: this.$t("persons.deliveryStatus"),
          sortable: false,
        },
        {
          key: "lastModifiedTime",
          label: this.$t("persons.lastModifiedTime"),
          sortable: true,
        },
      ],
      numberValidateFields: [
        {
          key: "key",
          label: "Key",
        },
        {
          key: "value",
          label: "Value",
        },
      ],
      useManageAttributes: useManageAttributes(),
      useSearch: useSearch(),
    };
  },
  computed: {
    form() {
      return this.useManageAttributes.getForm;
    },
    templates() {
      return this.useManageAttributes.templates;
    },
    id: {
      get() {
        return this.useManageAttributes.getForm.id;
      },
    },
    mobileNumber: {
      get() {
        return this.useManageAttributes.getForm.mobileNumber;
      },
      set(value) {
        this.useManageAttributes.updateValue({
          key: "mobileNumber",
          value: value,
        });
      },
    },
    isActive: {
      get() {
        return this.useManageAttributes.getForm.isActive;
      },
      set(value) {
        this.useManageAttributes.updateValue({
          key: "isActive",
          value: value,
        });
      },
    },
    numberValidate: {
      get() {
        return this.useManageAttributes.getForm.numberValidate;
      },
    },
    states() {
      return this.useManageAttributes.states;
    },
    searchMode() {
      return this.useSearch.getSearchMode();
    },
    pagination() {
      return this.useSearch.pagination;
    },
    items() {
      return this.useSearch.items;
    },
    states() {
      return this.useSearch.states;
    },
    errorMessage() {
      return this.useManageAttributes.errorMessage;
    },
    hasErrors() {
      let hasError = false;
      Object.keys(this.errors).forEach((k) => {
        if (this.errors[k]) {
          hasError = this.errors[k];
        }
      });
      return hasError;
    },
    numberValidateFormatted() {
      return this.numberValidate
        ? Object.entries(this.numberValidate).map((item) => {
            return { key: item[0], value: item[1] };
          })
        : [];
    },
    disableForm() {
      return this.useManageAttributes.disableForm;
    },
    disableCancel() {
      return this.useManageAttributes.disableCancel;
    },
  },
  watch: {
    "states.searching": function (newVal, oldVal) {
      if (newVal) {
        this.interaction
          ? this.fetchOutboundMessages()
          : this.fetchInboundMessages();
      }
    },
  },
  methods: {
    onTabChange() {
      this.useSearch.setPage(1);
      this.useSearch.setLimit(10);
    },
    checkType(value) {
      if (typeof value === "boolean") {
        return value.toString();
      }
      return value;
    },
    hasError(field) {
      if (!this.form[field] || this.form[field].length == 0) {
        this.errors[field] = true;
        return true;
      } else {
        this.errors[field] = false;
        return false;
      }
    },
    fetchPerson() {
      this.useManageAttributes.updateStates({
        fetching: true,
      });
      PersonsApi.find(this.personId, this.instanceId)
        .then((r) => {
          this.useManageAttributes.initialize({
            ...r.data,
            disableDelete: true,
            disableUpdate: true,
          });
          this.useManageAttributes.updateHeaders(r.headers);
        })
        .catch((e) => {
          let errorMessage = this.$t("persons.find_failed");
          if (e.response && e.response.status == 404) {
            errorMessage = this.$t("commons.not_found");
            this.useManageAttributes.updateStates({
              fetching: false,
              invalid: true,
            });
          } else {
            this.useManageAttributes.updateStates({
              fetching: false,
            });
          }
          this.useManageAttributes.setErrorMessage(errorMessage);
          this.$toast.error("Error", errorMessage);
        });
    },
    fetchInboundMessages() {
      this.useSearch.setItems([]);
      this.inbound_messages = [];
      let filters = this.useSearch.searchCriteria;
      filters += this.useSearch.getActiveFilter;
      let params = {
        filters: filters,
        limit: this.pagination.limit,
        offset: (this.pagination.page - 1) * this.pagination.limit,
      };
      PersonsApi.getInboundMessages(this.personId, this.instanceId, params)
        .then((response) => {
          response.result.forEach((element) => {
            let item = {
              id: element.id,
              type: "inbound",
              message: element.message,
              messageAlias: element.messageAlias,
              inboundMessageId: element.inboundMessageId,
              lastModifiedTime: element.lastModifiedTime,
              originationNumber: element.originationNumber,
              messageEngine: element.messageEngine,
            };
            this.inbound_messages.push(item);
          });
          this.useSearch.setItems(this.inbound_messages);
          this.useSearch.updateStates({
            searching: false,
          });
        })
        .catch((e) => {
          this.useSearch.updateStates({
            searching: false,
          });
          let errorMessage = this.$t("persons.search_failed");
          if (e.response && e.response.status == 400) {
            errorMessage = e.response.data.data.detail;
          }
          this.$toast.error("Error", errorMessage);
        });
    },
    fetchOutboundMessages() {
      this.outbound_messages = [];
      this.useSearch.setItems([]);
      let filters = this.useSearch.searchCriteria;
      filters += this.useSearch.getActiveFilter;
      let params = {
        filters: filters,
        limit: this.pagination.limit,
        offset: (this.pagination.page - 1) * this.pagination.limit,
      };
      PersonsApi.getOutboundMessages(this.personId, this.instanceId, params)
        .then((response) => {
          response.result.forEach((element) => {
            let item = {
              id: element.id,
              type: "outbound",
              message: element.message,
              messageTemplateId: element.messageTemplateId,
              lastModifiedTime: element.lastModifiedTime,
              originationNumber: element.originationNumber,
              destinationNumber: element.destinationNumber,
              deliveryStatus: element.deliveryStatus,
              messageEngine: element.messageEngine,
            };
            this.outbound_messages.push(item);
            this.useSearch.setItems(this.outbound_messages);
          });
          this.useSearch.updateStates({
            searching: false,
          });
        })
        .catch((e) => {
          this.useSearch.updateStates({
            searching: false,
          });
          let errorMessage = this.$t("persons.search_failed");
          if (e.response && e.response.status == 400) {
            errorMessage = e.response.data.data.detail;
          }
          this.$toast.error("Error", errorMessage);
        });
    },
    initForm() {
      let formData = {
        result: {
          isActive: null,
        },
      };
      this.useManageAttributes.initialize(formData);
    },
    onSubmit() {
      this.show_errors = true;

      this.updatePerson();
    },
    updatePerson() {
      this.useManageAttributes.updateStates({
        showErrors: true,
      });
      if (this.hasErrors || this.errors["attributesError"] != false) {
        this.$toast.error("Error", this.$t("commons.form_error"));
        return;
      }
      this.form.attributesJson = JSON.stringify(this.form);
      this.useManageAttributes.updateStates({
        saving: true,
        showSuccess: false,
      });

      let eTag = null;
      let headers = this.useManageAttributes.headers;

      if (headers && headers["ETag"] && headers["ETag"].length > 0) {
        eTag = headers["ETag"][0];
      }

      let payload = {
        payload: {
          id: this.form.id,
          mobileNumber: this.form.mobileNumber,
          isActive: this.form.isActive,
          attributes: this.form.attributes,
        },
        eTag: eTag,
      };
      PersonsApi.update(payload, this.instanceId, this.personId)
        .then((r) => {
          this.useManageAttributes.updateStates({
            showSuccess: true,
          });
          this.$toast.success("Success", this.$t("persons.saved_successfully"));
          this.useManageAttributes.initialize({
            ...r.data,
            disableDelete: true,
            disableUpdate: true,
          });

          this.useManageAttributes.updateHeaders(r.headers);
          this.useManageAttributes.updateStates({
            saving: false,
            showSuccess: true,
          });
        })
        .catch((e) => {
          this.useManageAttributes.updateStates({
            saving: false,
          });

          let errorMessage = "Unable to update person record.";
          if (e.response.status == 412) {
            errorMessage = this.$t("commons.optimistic_lock");
            this.useManageAttributes.setErrorMessage(errorMessage);
            this.invalid = true;
          } else if (e.response.status == 400) {
            errorMessage = e.response.data.data.detail;
            this.useManageAttributes.setErrorMessage(errorMessage);
          }
          this.$toast.error("Error", errorMessage);
        });
    },
    onError(e) {
      this.$emit("error", e);
    },
    onInput(e) {
      this.json = e;
      this.$emit("input", e);
    },
  },
};
</script>
